module.exports = __webpack_public_path__ + "img/pleat_depth_hipline.987ca51e.png";